import Styles from "./view_blog.module.css";
import { Code, Headline, Image } from "../../subcomponents/subcomponents";
import { useState } from "react";
export const Blog = ( props ) => {
    const { blogMainHeader, blogMainContent, blogMainFooter } = props;
    const { bloggerImg, bloggerName, blogLink               } = blogMainHeader;
    const { blogMainContentHeader, blogContent              } = blogMainContent;
    const { rate                                            } = blogMainFooter;
    const { Blog } = Styles;
    return (
        <div className={ Blog }>
            <BlogMainHeader
                bloggerImg  = { bloggerImg  }
                bloggerName = { bloggerName }
                blogLink    = { blogLink    }
            />
            <BlogMainContent 
                blogMainContentHeader = { blogMainContentHeader }
                blogContent           = { blogContent           }
            />
            <BlogMainFooter rate = { rate }/>
        </div>
    );
};
//header
const BlogMainHeader = ( props ) => {
    const { bloggerImg, bloggerName, blogLink } = props;
    const { BlogMainHeader } = Styles;
    const copyText = _=> {
        navigator.clipboard.writeText( blogLink )
        .then (_=> alert("blog link copied to clipboard!"))
        .catch(_=> alert("blog link faild to be copied to clipboard!!"));
    }
    return (
        <header className={ BlogMainHeader }>
            <div>
                <div><img src={ bloggerImg }/></div>
                <span></span>
                <h1><bdi>{ bloggerName }</bdi></h1>
            </div>
            <div>
                <i className="bi bi-share-fill" onClick={ copyText }></i>
            </div>
        </header>
    );
};
//main content
const BlogMainContent = ( props ) => {
    const { blogMainContentHeader, blogContent = [] } = props;
    const { blogTitle, blogTitleIcon, date } = blogMainContentHeader;
    const { BlogMainContent } = Styles;
    return (
        <div className={ BlogMainContent }>
            <BlogMainContentHeader 
                blogTitle     = { blogTitle                           }
                blogTitleIcon = { <i className={ blogTitleIcon }></i> }
                date          = { date                                }
            />
            { blogContent.map(( value, key ) => { 
                const { headline, code, image, captions } = value;
                return (
                    <BlogContent 
                        headline = { headline }
                        code     = { code     }
                        image    = { image    }
                        captions = { captions }
                        key      = { key      }
                    />
                );
            })}
        </div>
    );
};
const BlogMainContentHeader = ( props ) => {
    const { blogTitleIcon, blogTitle, date } = props;
    const { BlogMainContentHeader } = Styles;
    return (
        <header className={ BlogMainContentHeader }>
            { blogTitleIcon }
            <span></span>
            <span><bdi>{ blogTitle }</bdi></span>
            <span><bdi>{ date      }</bdi></span>
        </header>
    );
};
const BlogContent = ( props ) => {
    const { headline = { }, code = { }, image = { }, captions = [ ] } = props;
    const { BlogContent } = Styles;
    const { icon, subIcon, headlineText, headlineTheme, headlineLink } = headline;
    const { codeText, codeType, codeTheme                    } = code;
    const { imageSrc, imageTheme, imageLink                  } = image;
    return (
        <main className={ BlogContent }>
            { headlineText && <Headline
                icon    = { icon          && icon          }
                subIcon = { subIcon       && subIcon       }
                text    = { headlineText  && headlineText  }
                theme   = { headlineTheme && headlineTheme }
                link    = { headlineLink  && headlineLink  }
            />}
            { codeText     && <Code 
                code      = { codeText  && codeText  }
                codeType  = { codeType  && codeType  }
                theme     = { codeTheme && codeTheme }
            />}
            { imageSrc    && <Image 
                src   = { imageSrc   && imageSrc   }
                theme = { imageTheme && imageTheme }
                link  = { imageLink  && imageLink  }
            />}
            { captions.length !== 0  && <Caption captions = { captions }/>}
        </main>
    );
};
const Caption           = ( props ) => {
    const { captions = [] } = props;
    const { Caption, caption } = Styles;
    return ( 
        <div className={ Caption }>
            {
                captions.map(( value, key ) => {
                    const { title, text } = value;
                    return (
                        <div className={ caption } key={ key }>
                            <h2><bdi>{ title }</bdi></h2>
                            <p ><bdi>{ text  }</bdi></ p>
                        </div>
                    );
                })
            }
        </div>
    );
};
//footer
const BlogMainFooter = ( props ) => {
    const { rate } = props;
    const { BlogMainFooter } = Styles;
    const [ Rate, setRate ] = useState(rate);
    return (
        <footer className={ BlogMainFooter }>
            <span><bdi>Was this helpful?</bdi></span>
            <div>
                <button onClick={ _=> setRate( rate + 1) }><i className="bi bi-caret-up-square"></i></button>
                <span>{ Rate }</span>
                <button onClick={ _=> setRate( rate - 1) }><i className="bi bi-caret-down-square"></i></button>
            </div>
        </footer>
    );
};